import { cn } from '@/lib/utils'

/**
 * The Fairmeadow roofline — the mark from logo.png (a pitched roof with a
 * chimney on the left slope), redrawn as a stroke so it stays crisp at header
 * size and takes `currentColor`.
 */
export function RooflineMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 100 24" fill="none" aria-hidden="true" className={className}>
      <path d="M14 18V3h7v12.5z" fill="currentColor" />
      <path d="M2 22.5 50 2.5l48 20" stroke="currentColor" strokeWidth="3.6" />
    </svg>
  )
}

/**
 * Wordmark laid out as in the logo: the roof sits over "Fairmeadow", centred
 * and about two-thirds its width. Sized by the parent's font-size.
 */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn('inline-block pt-[0.5em] font-serif leading-none whitespace-nowrap', className)}>
      <span className="relative inline-block">
        <RooflineMark className="absolute bottom-[calc(100%-0.08em)] left-1/2 h-auto w-[62%] -translate-x-1/2" />
        Fairmeadow
      </span>{' '}
      Capital
    </span>
  )
}
